<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>{{ title }}</h1>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>

          <div class="card-body pb-0">
            <div class="row">
              <div class="col-md-9">
                <div class="form-group">
                  <label class="control-label">Group Name</label>
                  <input
                    v-model="value.grp_name"
                    id="assigned_to_group"
                    name="assigned_to_group"
                    class="form-control assigned_to_group"
                    readonly
                  />
                </div>
                <!-- Blocked Categories -->
                <div class="panel panel-default bg-light p-3 rounded mb-3">
                  <div class="d-flex align-items-center">
                    <div class="switch-row">
                      <label class="switch-label fw-600">Blocked Categories</label>
                    </div>
                    <label class="switch ml-auto">
                      <input
                        type="checkbox"
                        @click="sliderForceUpdate('blockcategory_enable')"
                        v-model="value.blockcategory_enable"
                        id="blocked_categories"
                      />
                      <div class="slider round"></div>
                    </label>
                  </div>
                  <div v-if="value.blockcategory_enable" class="category-container mt-3">
                    <div
                      v-for="(predefinedBlockedCategory, index) in Object.values(
                        value.blockCategories
                      )"
                      :key="index"
                      class="category-item"
                    >
                      <span
                        @click="
                          addRemoveCategory('blockcategory', predefinedBlockedCategory)
                        "
                        :class="{
                          'checkbox-block-box': true,
                          'checkbox-block': value.blockcategory.includes(
                            predefinedBlockedCategory
                          ),
                        }"
                        >{{ predefinedBlockedCategory.toUpperCase() }}</span
                      >
                    </div>
                  </div>
                </div>

                <!-- Blocked Sites -->
                <div class="panel panel-default bg-light p-3 rounded mb-3">
                  <div class="d-flex align-items-center">
                    <div class="switch-row">
                      <label class="switch-label fw-600">Blocked Sites</label>
                    </div>
                    <label class="switch ml-auto">
                      <input
                        type="checkbox"
                        @click="sliderForceUpdate('blocksite_enable')"
                        v-model="value.blocksite_enable"
                        id="blocked_sites"
                      />
                      <div class="slider round"></div>
                    </label>
                  </div>
                  <div v-if="value.blocksite_enable" class="form-group mt-3">
                    <input
                      v-model="value.blockSitesUserDefined"
                      class="form-control blockSitesUserDefined"
                      placeholder="Enter domain name to blocked by comma-separated. Example : abc,xyz"
                      id="blockSitesUserDefined"
                      @keyup="setDomainsErrors($event)"
                      name="blockSitesUserDefined"
                    />
                    
                    <div class="help text-danger" v-show="hasBlockSitesError">
                      Each domain must be less than 50 characters.
                    </div>
                  </div>
                  <div v-if="value.blocksite_enable" class="category-container">
                    <div
                      v-for="(predefinedBlockSite, index) in Object.values(
                        value.blockSites
                      )"
                      :key="index"
                      class="category-item"
                    >
                      <span
                        @click="
                          addRemoveCategory('enabledBlockSites', predefinedBlockSite)
                        "
                        :class="{
                          'checkbox-block-box': true,
                          'checkbox-block': value.enabledBlockSites.includes(
                            predefinedBlockSite
                          ),
                        }"
                        >{{ predefinedBlockSite.toUpperCase() }}</span
                      >
                    </div>
                  </div>
                </div>

                <!-- Blocked IP Group -->
                <div class="panel panel-default bg-light p-3 rounded mb-3">
                  <div class="d-flex align-items-center">
                    <div class="switch-row">
                      <label class="switch-label fw-600">Blocked IP Group</label>
                    </div>
                    <label class="switch ml-auto">
                      <input
                        type="checkbox"
                        @click="sliderForceUpdate('blocked_ip_group_enable')"
                        v-model="value.blocked_ip_group_enable"
                        id="blocked_ip_groups"
                      />
                      <div class="slider round"></div>
                    </label>
                  </div>
                  <div v-if="value.blocked_ip_group_enable">
                    <div
                      v-for="(blockIp, index) in value['block-ip-list']"
                      :key="index"
                      class=""
                    >
                      <div class="form-group mt-3">
                        <label class="control-label">IP Group</label>
                        <multiselect
                          :select-label="''"
                          :deselect-label="'Remove'"
                          v-model="blockIp.ip_group"
                          :options="value.ipGroupUserDefinedDefaultAry"
                          placeholder="Select ip group"
                          :searchable="true"
                          :multiple="false"
                          :id="'ip_group_' + index"
                          @input="forceUpdate"
                          v-bind:class="{
                            'has-error': errors.has('ip_group_' + index),
                          }"
                          :name="'ip_group_' + index"
                        >
                        </multiselect>

                        <div
                          class="help text-danger"
                          v-show="errors.has('ip_group_' + index)"
                        >
                          {{ errors.first("ip_group_" + index) }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="checkbox fw-500">
                          <input
                            type="checkbox"
                            id="block-ip-list-advanced-selector"
                            @click="checkboxForceUpdate(index, 'block-ip-list')"
                            v-model="blockIp.is_advance"
                          />
                          <span class="checkmark"></span>Advance Settings</label
                        >
                      </div>

                      <div v-if="blockIp.is_advance" class="form-group">
                        <label class="control-label">Protocol</label>
                        <!-- <multiselect
                          :select-label="''"
                          :deselect-label="'Remove'"
                          v-model="blockIp.protocol"
                          :options="pre.protocols"
                          placeholder="Select Protocol"
                          :searchable="true"
                          :id="'protocol_' + index"
                          @input="forceUpdate"
                          v-bind:class="{
                            'has-error': errors.has('protocol_' + index),
                          }"
                          :name="'protocol_' + index"
                        >
                        </multiselect> -->

                        <div class="d-flex">
                          <label
                            class="radio mr-3"
                            v-for="(protocol, pIndex) in ['TCP', 'ICMP', 'UDP']"
                            :key="index"
                          >
                            <input
                              type="radio"
                              :value="protocol"
                              v-model="blockIp.protocol"
                              :name="'protocol_' + index + 'blockedIP'"
                              :id="'protocol_' + index + 'blockedIP'"
                              v-validate=""
                            />
                            <span class="radio-mark"></span>{{ protocol }}
                          </label>
                        </div>
                      </div>

                      <!-- TCP Protocol -->
                      <div v-if="blockIp.protocol == 'TCP' && blockIp.is_advance">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label class="control-label">Source Port</label>
                              <multiselect
                                :select-label="''"
                                :deselect-label="'Remove'"
                                v-model="blockIp['tcp-source-port']"
                                :options="value.portGroupUserDefinedDefaultAry"
                                placeholder="Select port"
                                :searchable="true"
                                :id="'tcp-source-port_' + index"
                                @input="forceUpdate"
                                v-bind:class="{
                                  'has-error': errors.has('tcp-source-port_' + index),
                                }"
                                :name="'tcp-source-port_' + index"
                              >
                              </multiselect>
                            </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-group">
                              <label class="control-label">Destination Port</label>
                              <multiselect
                                :select-label="''"
                                :deselect-label="'Remove'"
                                v-model="blockIp['tcp-destination-port']"
                                :options="value.portGroupUserDefinedDefaultAry"
                                placeholder="Select port"
                                :searchable="true"
                                :id="'tcp-destination-port_' + index"
                                @input="forceUpdate"
                                v-bind:class="{
                                  'has-error': errors.has(
                                    'tcp-destination-port_' + index
                                  ),
                                }"
                                :name="'tcp-destination-port_' + index"
                              >
                              </multiselect>
                            </div>
                          </div>

                          <div style="display: none" class="col-md-6">
                            <div class="form-group">
                              <label class="control-label">TCP Flag</label>
                              <multiselect
                                :select-label="''"
                                :deselect-label="'Remove'"
                                v-model="blockIp['tcp-flag']"
                                :options="pre.flagOptions"
                                placeholder="Select port"
                                :searchable="true"
                                :multiple="true"
                                :id="'tcp-flag_' + index"
                                @input="forceUpdate"
                                v-bind:class="{
                                  'has-error': errors.has('tcp-flag_' + index),
                                }"
                                :name="'tcp-flag_' + index"
                              >
                              </multiselect>
                            </div>
                          </div>

                          <div style="display: none" class="col-md-6">
                            <div class="form-group">
                              <label class="control-label">TCP Mask</label>
                              <multiselect
                                :select-label="''"
                                :deselect-label="'Remove'"
                                v-model="blockIp['tcp-mask']"
                                :options="pre.flagOptions"
                                placeholder="Select port"
                                :searchable="true"
                                :multiple="true"
                                :id="'tcp-mask_' + index"
                                @input="forceUpdate"
                                v-bind:class="{
                                  'has-error': errors.has('tcp-mask_' + index),
                                }"
                                :name="'tcp-mask_' + index"
                              >
                              </multiselect>
                            </div>
                          </div>

                          <div style="display: none" class="col-md-12">
                            <div class="form-group">
                              <label class="control-label">Conn. State</label>
                              <multiselect
                                :select-label="''"
                                :deselect-label="'Remove'"
                                v-model="blockIp['conn-state']"
                                :options="pre.connStates"
                                placeholder="Select port"
                                :searchable="true"
                                :multiple="true"
                                :id="'conn-state_' + index"
                                @input="forceUpdate"
                                v-bind:class="{
                                  'has-error': errors.has('conn-state_' + index),
                                }"
                                :name="'conn-state_' + index"
                              >
                              </multiselect>
                            </div>
                          </div>
                          <div style="display: none" class="col-md-6">
                            <div class="form-group">
                              <label for="tcp-limit-s" class="control-label"
                                >Limit/S</label
                              >
                              <input
                                name="tcp-limit-s"
                                type="text"
                                v-model="blockIp['tcp-limit-s']"
                                class="form-control"
                                placeholder="Limit/S"
                              />
                            </div>
                          </div>
                          <div style="display: none" class="col-md-6">
                            <div class="form-group">
                              <label for="tcp-burst-rate" class="control-label"
                                >Burst Rate</label
                              >
                              <input
                                name="tcp-burst-rate"
                                type="text"
                                v-model="blockIp['tcp-burst-rate']"
                                class="form-control"
                                placeholder="Burst Rate"
                              />
                            </div>
                          </div>

                          <div style="display: none" class="col-md-6">
                            <div class="form-group">
                              <label for="tcp-conn-limit-value" class="control-label"
                                >Value</label
                              >
                              <input
                                name="tcp-conn-limit-value"
                                v-model="blockIp['tcp_conn_limit_value']"
                                type="text"
                                class="form-control"
                                placeholder="Value"
                              />
                            </div>
                          </div>
                          <div style="display: none" class="col-md-6">
                            <div class="form-group">
                              <label for="tcp-conn-limit-mask" class="control-label"
                                >Mask</label
                              >
                              <input
                                name="tcp-conn-limit-mask"
                                v-model="blockIp['tcp_Conn_limit_mask']"
                                type="text"
                                class="form-control"
                                placeholder="Mask"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="blockIp.protocol == 'UDP' && blockIp.is_advance">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label class="control-label">Source Port</label>
                              <multiselect
                                :select-label="''"
                                :deselect-label="'Remove'"
                                v-model="blockIp['udp-source-port']"
                                :options="value.portGroupUserDefinedDefaultAry"
                                placeholder="Select port"
                                :searchable="true"
                                :id="'udp-source-port_' + index"
                                @input="forceUpdate"
                                v-bind:class="{
                                  'has-error': errors.has('udp-source-port_' + index),
                                }"
                                :name="'udp-source-port_' + index"
                              >
                              </multiselect>
                            </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-group">
                              <label class="control-label">Destination Port</label>
                              <multiselect
                                :select-label="''"
                                :deselect-label="'Remove'"
                                v-model="blockIp['udp-destination-port']"
                                :options="value.portGroupUserDefinedDefaultAry"
                                placeholder="Select port"
                                :searchable="true"
                                :id="'udp-destination-port_' + index"
                                @input="forceUpdate"
                                v-bind:class="{
                                  'has-error': errors.has(
                                    'udp-destination-port_' + index
                                  ),
                                }"
                                :name="'udp-destination-port_' + index"
                              >
                              </multiselect>
                            </div>
                          </div>

                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="udp-limit-s" class="control-label"
                                >Limit/S</label
                              >
                              <input
                                name="udp-limit-s"
                                type="text"
                                v-model="blockIp['udp-limit-s']"
                                class="form-control"
                                placeholder="Limit/S"
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="udp-burst-rate" class="control-label"
                                >Burst Rate</label
                              >
                              <input
                                name="udp-burst-rate"
                                type="text"
                                v-model="blockIp['udp-burst-rate']"
                                class="form-control"
                                placeholder="Burst Rate"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-if="blockIp.protocol == 'ICMP' && blockIp.is_advance">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="icmp-type" class="control-label"
                                >ICMP Type</label
                              >
                              <input
                                name="icmp-type"
                                type="text"
                                v-model="blockIp['icmp-type']"
                                class="form-control"
                                placeholder="ICMP Type"
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="icmp-limit" class="control-label"
                                >ICMP Limit</label
                              >
                              <input
                                name="icmp-limit"
                                type="text"
                                v-model="blockIp['icmp-limit']"
                                class="form-control"
                                placeholder="ICMP Limit"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex justify-content-end border-bottom pb-3 mb-3">
                        <a
                          class="text-danger fw-500"
                          @click="removeGroup(index, 'block-ip-list')"
                        >
                          <i class="icon-trash"></i> Remove
                        </a>
                      </div>
                    </div>

                    <div
                      class="text-right"
                      :class="{
                        'mt-3 pt-2 border-top': !value['block-ip-list'].length > 0,
                      }"
                    >
                      <a
                        @click.prevent="addMoreGroup('block-ip-list', 'ip_group')"
                        class="pc fw-500"
                      >
                        <i class="fas fa-plus-circle"></i> New
                      </a>
                    </div>
                  </div>
                </div>

                <!-- Blocked Domain Group -->
                <div class="panel panel-default bg-light p-3 rounded mb-3">
                  <div class="d-flex align-items-center">
                    <div class="switch-row">
                      <label class="switch-label fw-600">Blocked Domain Group</label>
                    </div>
                    <label class="switch ml-auto">
                      <input
                        type="checkbox"
                        @click="sliderForceUpdate('blocked_domain_group_enable')"
                        v-model="value.blocked_domain_group_enable"
                        id="blocked_domain_group_enable"
                      />
                      <div class="slider round"></div>
                    </label>
                  </div>
                  <div v-if="value.blocked_domain_group_enable">
                    <div
                      v-for="(blockDomain, index) in value['block-domain-list']"
                      :key="index"
                      class="duplicate-row"
                    >
                      <div class="form-group mt-3">
                        <label class="control-label">Domain Group</label>
                        <multiselect
                          :select-label="''"
                          :deselect-label="'Remove'"
                          v-model="blockDomain.domain_group"
                          :options="value.domainGroupUserDefinedDefaultAry"
                          placeholder="Select Domain Group"
                          :searchable="true"
                          :multiple="false"
                          :id="'domain_group_' + index"
                          @input="forceUpdate"
                          v-bind:class="{
                            'has-error': errors.has('domain_group_' + index),
                          }"
                          :name="'domain_group_' + index"
                        >
                        </multiselect>

                        <div
                          class="help text-danger"
                          v-show="errors.has('domain_group_' + index)"
                        >
                          {{ errors.first("domain_group_" + index) }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="checkbox fw-500">
                          <input
                            type="checkbox"
                            id="block-domain-list-advanced-selector"
                            @click="checkboxForceUpdate(index, 'block-domain-list')"
                            v-model="blockDomain.is_advance"
                          />
                          <span class="checkmark"></span>Advance Settings</label
                        >
                      </div>

                      <div v-if="blockDomain.is_advance" class="form-group">
                        <label class="control-label">Protocol</label>
                        <!-- <multiselect
                          :select-label="''"
                          :deselect-label="'Remove'"
                          v-model="blockDomain.protocol"
                          :options="pre.protocols"
                          placeholder="Select ip group"
                          :searchable="true"
                          :id="'protocol_' + index"
                          @input="forceUpdate"
                          v-bind:class="{
                            'has-error': errors.has('protocol_' + index),
                          }"
                          :name="'protocol_' + index"
                        >
                        </multiselect> -->
                        <div class="d-flex">
                          <label
                            class="radio mr-3"
                            v-for="(protocol, pIndex) in ['TCP', 'ICMP', 'UDP']"
                            :key="index"
                          >
                            <input
                              type="radio"
                              :value="protocol"
                              v-model="blockDomain.protocol"
                              :name="'protocol_' + index + 'blockedDomain'"
                              :id="'protocol_' + index + 'blockedDomain'"
                              v-validate=""
                            />
                            <span class="radio-mark"></span>{{ protocol }}
                          </label>
                        </div>
                      </div>

                      <!-- TCP Protocol -->
                      <div
                        v-if="blockDomain.protocol == 'TCP' && blockDomain.is_advance"
                        class="row"
                      >
                        <div class="form-group col-md-6">
                          <label class="control-label">Source Port</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="blockDomain['tcp-source-port']"
                            :options="value.portGroupUserDefinedDefaultAry"
                            placeholder="Select port"
                            :searchable="true"
                            :id="'tcp-source-port_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('tcp-source-port_' + index),
                            }"
                            :name="'tcp-source-port_' + index"
                          >
                          </multiselect>
                        </div>

                        <div class="form-group col-md-6">
                          <label class="control-label">Destination Port</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="blockDomain['tcp-destination-port']"
                            :options="value.portGroupUserDefinedDefaultAry"
                            placeholder="Select port"
                            :searchable="true"
                            :id="'tcp-destination-port_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('tcp-destination-port_' + index),
                            }"
                            :name="'tcp-destination-port_' + index"
                          >
                          </multiselect>
                        </div>

                        <div style="display: none" class="form-group col-md-6">
                          <label class="control-label">TCP Flag</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="blockDomain['tcp-flag']"
                            :options="pre.flagOptions"
                            placeholder="Select port"
                            :searchable="true"
                            :multiple="true"
                            :id="'tcp-flag_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('tcp-flag_' + index),
                            }"
                            :name="'tcp-flag_' + index"
                          >
                          </multiselect>
                        </div>

                        <div style="display: none" class="form-group col-md-6">
                          <label class="control-label">TCP Mask</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="blockDomain['tcp-mask']"
                            :options="pre.flagOptions"
                            placeholder="Select port"
                            :searchable="true"
                            :multiple="true"
                            :id="'tcp-mask_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('tcp-mask_' + index),
                            }"
                            :name="'tcp-mask_' + index"
                          >
                          </multiselect>
                        </div>

                        <div style="display: none" class="form-group col-md-12">
                          <label class="control-label">Conn. State</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="blockDomain['conn-state']"
                            :options="pre.connStates"
                            placeholder="Select port"
                            :searchable="true"
                            :multiple="true"
                            :id="'conn-state_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('conn-state_' + index),
                            }"
                            :name="'conn-state_' + index"
                          >
                          </multiselect>
                        </div>
                        <div style="display: none" class="form-group col-md-6">
                          <label for="tcp-limit-s" class="control-label">Limit/S</label>
                          <input
                            name="tcp-limit-s"
                            type="text"
                            v-model="blockDomain['tcp-limit-s']"
                            class="form-control"
                            placeholder="Limit/S"
                          />
                        </div>
                        <div style="display: none" class="form-group col-md-6">
                          <label for="tcp-burst-rate" class="control-label"
                            >Burst Rate</label
                          >
                          <input
                            name="tcp-burst-rate"
                            type="text"
                            v-model="blockDomain['tcp-burst-rate']"
                            class="form-control"
                            placeholder="Burst Rate"
                          />
                        </div>

                        <div style="display: none" class="form-group col-md-6">
                          <label for="tcp-conn-limit-value" class="control-label"
                            >Value</label
                          >
                          <input
                            name="tcp-conn-limit-value"
                            v-model="blockDomain['tcp_conn_limit_value']"
                            type="text"
                            class="form-control"
                            placeholder="Value"
                          />
                        </div>
                        <div style="display: none" class="form-group col-md-6">
                          <label for="tcp-conn-limit-mask" class="control-label"
                            >Mask</label
                          >
                          <input
                            name="tcp-conn-limit-mask"
                            v-model="blockDomain['tcp_Conn_limit_mask']"
                            type="text"
                            class="form-control"
                            placeholder="Mask"
                          />
                        </div>
                      </div>

                      <div
                        v-if="blockDomain.protocol == 'UDP' && blockDomain.is_advance"
                        class="row"
                      >
                        <div class="form-group col-md-6">
                          <label class="control-label">Source Port</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="blockDomain['udp-source-port']"
                            :options="value.portGroupUserDefinedDefaultAry"
                            placeholder="Select port"
                            :searchable="true"
                            :id="'udp-source-port_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('udp-source-port_' + index),
                            }"
                            :name="'udp-source-port_' + index"
                          >
                          </multiselect>
                        </div>

                        <div class="form-group col-md-6">
                          <label class="control-label">Destination Port</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="blockDomain['udp-destination-port']"
                            :options="value.portGroupUserDefinedDefaultAry"
                            placeholder="Select port"
                            :searchable="true"
                            :id="'udp-destination-port_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('udp-destination-port_' + index),
                            }"
                            :name="'udp-destination-port_' + index"
                          >
                          </multiselect>
                        </div>

                        <div class="form-group col-md-6">
                          <label for="udp-limit-s" class="control-label">Limit/S</label>
                          <input
                            name="udp-limit-s"
                            type="text"
                            v-model="blockDomain['udp-limit-s']"
                            class="form-control"
                            placeholder="Limit/S"
                          />
                        </div>
                        <div class="form-group col-md-6">
                          <label for="udp-burst-rate" class="control-label"
                            >Burst Rate</label
                          >
                          <input
                            name="udp-burst-rate"
                            type="text"
                            v-model="blockDomain['udp-burst-rate']"
                            class="form-control"
                            placeholder="Burst Rate"
                          />
                        </div>
                      </div>

                      <div
                        v-if="blockDomain.protocol == 'ICMP' && blockDomain.is_advance"
                        class="row"
                      >
                        <div class="form-group col-md-6">
                          <label for="icmp-type" class="control-label">ICMP Type</label>
                          <input
                            name="icmp-type"
                            type="text"
                            v-model="blockDomain['icmp-type']"
                            class="form-control"
                            placeholder="ICMP Type"
                          />
                        </div>
                        <div class="form-group col-md-6">
                          <label for="icmp-limit" class="control-label">ICMP Limit</label>
                          <input
                            name="icmp-limit"
                            type="text"
                            v-model="blockDomain['icmp-limit']"
                            class="form-control"
                            placeholder="ICMP Limit"
                          />
                        </div>
                      </div>

                      <div class="d-flex justify-content-end border-bottom pb-3 mb-3">
                        <a
                          class="text-danger fw-500"
                          @click="removeGroup(index, 'block-domain-list')"
                        >
                          <i class="icon-trash"></i> Remove
                        </a>
                      </div>
                    </div>

                    <div
                      class="text-right"
                      :class="{
                        'mt-3 pt-2 border-top': !value['block-domain-list'].length > 0,
                      }"
                    >
                      <a
                        @click.prevent="addMoreGroup('block-domain-list', 'domain_group')"
                        class="pc fw-500"
                      >
                        <i class="fas fa-plus-circle"></i> New
                      </a>
                    </div>
                  </div>
                </div>

                <!-- WhiteList -->
                <div class="panel panel-default bg-light p-3 rounded mb-3">
                  <div class="d-flex align-items-center">
                    <div class="switch-row">
                      <label class="switch-label fw-600">WhiteList</label>
                    </div>
                    <label class="switch ml-auto">
                      <input
                        type="checkbox"
                        @click="sliderForceUpdate('whilelist_enable')"
                        v-model="value.whilelist_enable"
                        id="whitelist"
                      />
                      <div class="slider round"></div>
                    </label>
                  </div>
                  <div v-if="value.whilelist_enable" class="form-group">
                    <p class="col-md-12">
                      Once enabled, Audra will allow access only to websites entered or
                      selected below.
                    </p>
                    <input
                      v-model="value.whitelistSitesUserDefined"
                      class="form-control whitelistSitesUserDefined"
                      placeholder="Enter domain name to whitelist by comma-separated. Example : abc,xyz"
                      id="whitelistSitesUserDefined"
                      @keyup="setDomainsErrors($event)"
                      name="whitelistSitesUserDefined"
                    />
                    <div class="help text-danger" v-if="hasWhiteListError">
                      Each domain must be less than 50 characters.
                    </div>
                  </div>
                  <div v-if="value.whilelist_enable" class="category-container">
                    <div
                      v-for="(whiteList, index) in Object.values(value.whitelistSites)"
                      :key="index"
                      class="category-item"
                    >
                      <span
                        @click="addRemoveCategory('blockSitesWhiteList', whiteList)"
                        :class="{
                          'checkbox-block-box': true,
                          'checkbox-block': value.blockSitesWhiteList.includes(whiteList),
                        }"
                        >{{ whiteList.toUpperCase() }}</span
                      >
                    </div>
                  </div>
                </div>

                <!-- WhiteList IP Group -->
                <div class="panel panel-default bg-light p-3 rounded mb-3">
                  <div class="d-flex align-items-center">
                    <div class="switch-row">
                      <label class="switch-label fw-600">WhiteList IP Group</label>
                    </div>
                    <label class="switch ml-auto">
                      <input
                        type="checkbox"
                        v-model="value.whitelist_ip_group_enable"
                        id="whitelist_ip_groups"
                        @click="sliderForceUpdate('whitelist_ip_group_enable')"
                      />
                      <div class="slider round"></div>
                    </label>
                  </div>
                  <div v-if="value.whitelist_ip_group_enable">
                    <div
                      v-for="(whiteListIp, index) in value['whitelist-ip-list']"
                      :key="index"
                      class="duplicate-row"
                    >
                      <div class="form-group">
                        <label class="control-label">IP Group</label>
                        <multiselect
                          :select-label="''"
                          :deselect-label="'Remove'"
                          v-model="whiteListIp.ip_group"
                          :options="value.ipGroupUserDefinedDefaultAry"
                          placeholder="Select ip group"
                          :searchable="true"
                          :multiple="false"
                          :id="'ip_group_' + index"
                          @input="forceUpdate"
                          v-bind:class="{
                            'has-error': errors.has('ip_group_' + index),
                          }"
                          :name="'ip_group_' + index"
                        >
                        </multiselect>

                        <div
                          class="help text-danger"
                          v-show="errors.has('ip_group_' + index)"
                        >
                          {{ errors.first("ip_group_" + index) }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="checkbox fw-500">
                          <input
                            type="checkbox"
                            id="whitelist-ip-list-advanced-selector"
                            @click="checkboxForceUpdate(index, 'whitelist-ip-list')"
                            v-model="whiteListIp.is_advance"
                          />
                          <span class="checkmark"></span>Advance Settings</label
                        >
                      </div>

                      <div v-if="whiteListIp.is_advance" class="form-group">
                        <label class="control-label">Protocol</label>
                        <!-- <multiselect
                          :select-label="''"
                          :deselect-label="'Remove'"
                          v-model="whiteListIp.protocol"
                          :options="pre.protocols"
                          placeholder="Select Protocol"
                          :searchable="true"
                          :id="'protocol_' + index"
                          @input="forceUpdate"
                          v-bind:class="{
                            'has-error': errors.has('protocol_' + index),
                          }"
                          :name="'protocol_' + index"
                        >
                        </multiselect> -->
                        <div class="d-flex">
                          <label
                            class="radio mr-3"
                            v-for="(protocol, pIndex) in ['TCP', 'ICMP', 'UDP']"
                            :key="index"
                          >
                            <input
                              type="radio"
                              :value="protocol"
                              v-model="whiteListIp.protocol"
                              :name="'protocol_' + index + '_whiteListIp'"
                              :id="'protocol_' + index + '_whiteListIp'"
                              v-validate=""
                            />
                            <span class="radio-mark"></span>{{ protocol }}
                          </label>
                        </div>
                      </div>

                      <!-- TCP Protocol -->
                      <div
                        v-if="whiteListIp.protocol == 'TCP' && whiteListIp.is_advance"
                        class="row"
                      >
                        <div class="form-group col-md-6">
                          <label class="control-label">Source Port</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="whiteListIp['tcp-source-port']"
                            :options="value.portGroupUserDefinedDefaultAry"
                            placeholder="Select port"
                            :searchable="true"
                            :id="'tcp-source-port_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('tcp-source-port_' + index),
                            }"
                            :name="'tcp-source-port_' + index"
                          >
                          </multiselect>
                        </div>

                        <div class="form-group col-md-6">
                          <label class="control-label">Destination Port</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="whiteListIp['tcp-destination-port']"
                            :options="value.portGroupUserDefinedDefaultAry"
                            placeholder="Select port"
                            :searchable="true"
                            :id="'tcp-destination-port_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('tcp-destination-port_' + index),
                            }"
                            :name="'tcp-destination-port_' + index"
                          >
                          </multiselect>
                        </div>

                        <div style="display: none" class="form-group col-md-6">
                          <label class="control-label">TCP Flag</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="whiteListIp['tcp-flag']"
                            :options="pre.flagOptions"
                            placeholder="Select port"
                            :searchable="true"
                            :multiple="true"
                            :id="'tcp-flag_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('tcp-flag_' + index),
                            }"
                            :name="'tcp-flag_' + index"
                          >
                          </multiselect>
                        </div>

                        <div style="display: none" class="form-group col-md-6">
                          <label class="control-label">TCP Mask</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="whiteListIp['tcp-mask']"
                            :options="pre.flagOptions"
                            placeholder="Select port"
                            :searchable="true"
                            :multiple="true"
                            :id="'tcp-mask_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('tcp-mask_' + index),
                            }"
                            :name="'tcp-mask_' + index"
                          >
                          </multiselect>
                        </div>

                        <div style="display: none" class="form-group col-md-12">
                          <label class="control-label">Conn. State</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="whiteListIp['conn-state']"
                            :options="pre.connStates"
                            placeholder="Select port"
                            :searchable="true"
                            :multiple="true"
                            :id="'conn-state_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('conn-state_' + index),
                            }"
                            :name="'conn-state_' + index"
                          >
                          </multiselect>
                        </div>
                        <div style="display: none" class="form-group col-md-6">
                          <label for="tcp-limit-s" class="control-label">Limit/S</label>
                          <input
                            name="tcp-limit-s"
                            type="text"
                            v-model="whiteListIp['tcp-limit-s']"
                            class="form-control"
                            placeholder="Limit/S"
                          />
                        </div>
                        <div style="display: none" class="form-group col-md-6">
                          <label for="tcp-burst-rate" class="control-label"
                            >Burst Rate</label
                          >
                          <input
                            name="tcp-burst-rate"
                            type="text"
                            v-model="whiteListIp['tcp-burst-rate']"
                            class="form-control"
                            placeholder="Burst Rate"
                          />
                        </div>

                        <div style="display: none" class="form-group col-md-6">
                          <label for="tcp-conn-limit-value" class="control-label"
                            >Value</label
                          >
                          <input
                            name="tcp-conn-limit-value"
                            v-model="whiteListIp['tcp_conn_limit_value']"
                            type="text"
                            class="form-control"
                            placeholder="Value"
                          />
                        </div>
                        <div style="display: none" class="form-group col-md-6">
                          <label for="tcp-conn-limit-mask" class="control-label"
                            >Mask</label
                          >
                          <input
                            name="tcp-conn-limit-mask"
                            v-model="whiteListIp['tcp_Conn_limit_mask']"
                            type="text"
                            class="form-control"
                            placeholder="Mask"
                          />
                        </div>
                      </div>

                      <div
                        v-if="whiteListIp.protocol == 'UDP' && whiteListIp.is_advance"
                        class="row"
                      >
                        <div class="form-group col-md-6">
                          <label class="control-label">Source Port</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="whiteListIp['udp-source-port']"
                            :options="value.portGroupUserDefinedDefaultAry"
                            placeholder="Select port"
                            :searchable="true"
                            :id="'udp-source-port_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('udp-source-port_' + index),
                            }"
                            :name="'udp-source-port_' + index"
                          >
                          </multiselect>
                        </div>

                        <div class="form-group col-md-6">
                          <label class="control-label">Destination Port</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="whiteListIp['udp-destination-port']"
                            :options="value.portGroupUserDefinedDefaultAry"
                            placeholder="Select port"
                            :searchable="true"
                            :id="'udp-destination-port_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('udp-destination-port_' + index),
                            }"
                            :name="'udp-destination-port_' + index"
                          >
                          </multiselect>
                        </div>

                        <div class="form-group col-md-6">
                          <label for="udp-limit-s" class="control-label">Limit/S</label>
                          <input
                            name="udp-limit-s"
                            type="text"
                            v-model="whiteListIp['udp-limit-s']"
                            class="form-control"
                            placeholder="Limit/S"
                          />
                        </div>
                        <div class="form-group col-md-6">
                          <label for="udp-burst-rate" class="control-label"
                            >Burst Rate</label
                          >
                          <input
                            name="udp-burst-rate"
                            type="text"
                            v-model="whiteListIp['udp-burst-rate']"
                            class="form-control"
                            placeholder="Burst Rate"
                          />
                        </div>
                      </div>

                      <div
                        v-if="whiteListIp.protocol == 'ICMP' && whiteListIp.is_advance"
                        class="row"
                      >
                        <div class="form-group col-md-6">
                          <label for="icmp-type" class="control-label">ICMP Type</label>
                          <input
                            name="icmp-type"
                            type="text"
                            v-model="whiteListIp['icmp-type']"
                            class="form-control"
                            placeholder="ICMP Type"
                          />
                        </div>
                        <div class="form-group col-md-6">
                          <label for="icmp-limit" class="control-label">ICMP Limit</label>
                          <input
                            name="icmp-limit"
                            type="text"
                            v-model="whiteListIp['icmp-limit']"
                            class="form-control"
                            placeholder="ICMP Limit"
                          />
                        </div>
                      </div>

                      <div class="d-flex justify-content-end border-bottom pb-3 mb-3">
                        <a
                          class="text-danger fw-500"
                          @click="removeGroup(index, 'whitelist-ip-list')"
                        >
                          <i class="icon-trash"></i> Remove
                        </a>
                      </div>
                    </div>

                    <div
                      class="text-right"
                      :class="{
                        'mt-3 pt-2 border-top': !value['whitelist-ip-list'].length > 0,
                      }"
                    >
                      <a
                        @click.prevent="addMoreGroup('whitelist-ip-list', 'ip_group')"
                        class="pc fw-500"
                      >
                        <i class="fas fa-plus-circle"></i> New
                      </a>
                    </div>
                  </div>
                </div>

                <!-- WhiteList Domain Group -->
                <div class="panel panel-default bg-light p-3 rounded mb-3">
                  <div class="d-flex align-items-center">
                    <div class="switch-row">
                      <label class="switch-label fw-600">WhiteList Domain Group</label>
                    </div>
                    <label class="switch ml-auto">
                      <input
                        type="checkbox"
                        v-model="value.whitelist_domain_group_enable"
                        @click="sliderForceUpdate('whitelist_domain_group_enable')"
                        id="whitelist_domain_group_enable"
                      />
                      <div class="slider round"></div>
                    </label>
                  </div>
                  <div v-if="value.whitelist_domain_group_enable">
                    <div
                      v-for="(blockDomain, index) in value['whitelist-domain-list']"
                      :key="index"
                      class="duplicate-row"
                    >
                      <div class="form-group mt-3">
                        <label class="control-label">Domain Group</label>
                        <multiselect
                          :select-label="''"
                          :deselect-label="'Remove'"
                          v-model="blockDomain.domain_group"
                          :options="value.domainGroupUserDefinedDefaultAry"
                          placeholder="Select Domain Group"
                          :searchable="true"
                          :multiple="false"
                          :id="'domain_group_' + index"
                          @input="forceUpdate"
                          v-bind:class="{
                            'has-error': errors.has('domain_group_' + index),
                          }"
                          :name="'domain_group_' + index"
                        >
                        </multiselect>

                        <div
                          class="help text-danger"
                          v-show="errors.has('domain_group_' + index)"
                        >
                          {{ errors.first("domain_group_" + index) }}
                        </div>
                      </div>

                      <div class="form-group">
                        <label class="checkbox fw-500">
                          <input
                            type="checkbox"
                            id="whitelist-domain-list-advanced-selector"
                            @click="checkboxForceUpdate(index, 'whitelist-domain-list')"
                            v-model="blockDomain.is_advance"
                          />
                          <span class="checkmark"></span>Advance Settings</label
                        >
                      </div>

                      <div v-if="blockDomain.is_advance" class="form-group">
                        <label class="control-label">Protocol</label>
                        <!-- <multiselect
                          :select-label="''"
                          :deselect-label="'Remove'"
                          v-model="blockDomain.protocol"
                          :options="pre.protocols"
                          placeholder="Select ip group"
                          :searchable="true"
                          :id="'protocol_' + index"
                          @input="forceUpdate"
                          v-bind:class="{
                            'has-error': errors.has('protocol_' + index),
                          }"
                          :name="'protocol_' + index"
                        >
                        </multiselect> -->

                        <div class="d-flex">
                          <label
                            class="radio mr-3"
                            v-for="(protocol, pIndex) in ['TCP', 'ICMP', 'UDP']"
                            :key="index"
                          >
                            <input
                              type="radio"
                              :value="protocol"
                              v-model="blockDomain.protocol"
                              :name="'protocol_' + index + 'whiteListDomain'"
                              :id="'protocol_' + index + 'whiteListDomain'"
                              v-validate=""
                            />
                            <span class="radio-mark"></span>{{ protocol }}
                          </label>
                        </div>
                      </div>

                      <!-- TCP Protocol -->
                      <div
                        v-if="blockDomain.protocol == 'TCP' && blockDomain.is_advance"
                        class="row"
                      >
                        <div class="form-group col-md-6">
                          <label class="control-label">Source Port</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="blockDomain['tcp-source-port']"
                            :options="value.portGroupUserDefinedDefaultAry"
                            placeholder="Select port"
                            :searchable="true"
                            :id="'tcp-source-port_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('tcp-source-port_' + index),
                            }"
                            :name="'tcp-source-port_' + index"
                          >
                          </multiselect>
                        </div>

                        <div class="form-group col-md-6">
                          <label class="control-label">Destination Port</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="blockDomain['tcp-destination-port']"
                            :options="value.portGroupUserDefinedDefaultAry"
                            placeholder="Select port"
                            :searchable="true"
                            :id="'tcp-destination-port_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('tcp-destination-port_' + index),
                            }"
                            :name="'tcp-destination-port_' + index"
                          >
                          </multiselect>
                        </div>

                        <div style="display: none" class="form-group col-md-6">
                          <label class="control-label">TCP Flag</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="blockDomain['tcp-flag']"
                            :options="pre.flagOptions"
                            placeholder="Select port"
                            :searchable="true"
                            :multiple="true"
                            :id="'tcp-flag_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('tcp-flag_' + index),
                            }"
                            :name="'tcp-flag_' + index"
                          >
                          </multiselect>
                        </div>

                        <div style="display: none" class="form-group col-md-6">
                          <label class="control-label">TCP Mask</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="blockDomain['tcp-mask']"
                            :options="pre.flagOptions"
                            placeholder="Select port"
                            :searchable="true"
                            :multiple="true"
                            :id="'tcp-mask_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('tcp-mask_' + index),
                            }"
                            :name="'tcp-mask_' + index"
                          >
                          </multiselect>
                        </div>

                        <div style="display: none" class="form-group col-md-12">
                          <label class="control-label">Conn. State</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="blockDomain['conn-state']"
                            :options="pre.connStates"
                            placeholder="Select port"
                            :searchable="true"
                            :multiple="true"
                            :id="'conn-state_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('conn-state_' + index),
                            }"
                            :name="'conn-state_' + index"
                          >
                          </multiselect>
                        </div>
                        <div style="display: none" class="form-group col-md-6">
                          <label for="tcp-limit-s" class="control-label">Limit/S</label>
                          <input
                            name="tcp-limit-s"
                            type="text"
                            v-model="blockDomain['tcp-limit-s']"
                            class="form-control"
                            placeholder="Limit/S"
                          />
                        </div>
                        <div style="display: none" class="form-group col-md-6">
                          <label for="tcp-burst-rate" class="control-label"
                            >Burst Rate</label
                          >
                          <input
                            name="tcp-burst-rate"
                            type="text"
                            v-model="blockDomain['tcp-burst-rate']"
                            class="form-control"
                            placeholder="Burst Rate"
                          />
                        </div>

                        <div style="display: none" class="form-group col-md-6">
                          <label for="tcp-conn-limit-value" class="control-label"
                            >Value</label
                          >
                          <input
                            name="tcp-conn-limit-value"
                            v-model="blockDomain['tcp_conn_limit_value']"
                            type="text"
                            class="form-control"
                            placeholder="Value"
                          />
                        </div>
                        <div style="display: none" class="form-group col-md-6">
                          <label for="tcp-conn-limit-mask" class="control-label"
                            >Mask</label
                          >
                          <input
                            name="tcp-conn-limit-mask"
                            v-model="blockDomain['tcp_Conn_limit_mask']"
                            type="text"
                            class="form-control"
                            placeholder="Mask"
                          />
                        </div>
                      </div>

                      <div
                        v-if="blockDomain.protocol == 'UDP' && blockDomain.is_advance"
                        class="row"
                      >
                        <div class="form-group col-md-6">
                          <label class="control-label">Source Port</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="blockDomain['udp-source-port']"
                            :options="value.portGroupUserDefinedDefaultAry"
                            placeholder="Select port"
                            :searchable="true"
                            :id="'udp-source-port_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('udp-source-port_' + index),
                            }"
                            :name="'udp-source-port_' + index"
                          >
                          </multiselect>
                        </div>

                        <div class="form-group col-md-6">
                          <label class="control-label">Destination Port</label>
                          <multiselect
                            :select-label="''"
                            :deselect-label="'Remove'"
                            v-model="blockDomain['udp-destination-port']"
                            :options="value.portGroupUserDefinedDefaultAry"
                            placeholder="Select port"
                            :searchable="true"
                            :id="'udp-destination-port_' + index"
                            @input="forceUpdate"
                            v-bind:class="{
                              'has-error': errors.has('udp-destination-port_' + index),
                            }"
                            :name="'udp-destination-port_' + index"
                          >
                          </multiselect>
                        </div>

                        <div class="form-group col-md-6">
                          <label for="udp-limit-s" class="control-label">Limit/S</label>
                          <input
                            name="udp-limit-s"
                            type="text"
                            v-model="blockDomain['udp-limit-s']"
                            class="form-control"
                            placeholder="Limit/S"
                          />
                        </div>
                        <div class="form-group col-md-6">
                          <label for="udp-burst-rate" class="control-label"
                            >Burst Rate</label
                          >
                          <input
                            name="udp-burst-rate"
                            type="text"
                            v-model="blockDomain['udp-burst-rate']"
                            class="form-control"
                            placeholder="Burst Rate"
                          />
                        </div>
                      </div>

                      <div
                        v-if="blockDomain.protocol == 'ICMP' && blockDomain.is_advance"
                        class="row"
                      >
                        <div class="form-group col-md-6">
                          <label for="icmp-type" class="control-label">ICMP Type</label>
                          <input
                            name="icmp-type"
                            type="text"
                            v-model="blockDomain['icmp-type']"
                            class="form-control"
                            placeholder="ICMP Type"
                          />
                        </div>
                        <div class="form-group col-md-6">
                          <label for="icmp-limit" class="control-label">ICMP Limit</label>
                          <input
                            name="icmp-limit"
                            type="text"
                            v-model="blockDomain['icmp-limit']"
                            class="form-control"
                            placeholder="ICMP Limit"
                          />
                        </div>
                      </div>

                      <div class="d-flex justify-content-end border-bottom pb-3 mb-3">
                        <a
                          class="text-danger fw-500"
                          @click="removeGroup(index, 'whitelist-domain-list')"
                        >
                          <i class="icon-trash"></i> Remove
                        </a>
                      </div>
                    </div>
                    <div
                      class="text-right"
                      :class="{
                        'mt-3 pt-2 border-top':
                          !value['whitelist-domain-list'].length > 0,
                      }"
                    >
                      <a
                        @click.prevent="
                          addMoreGroup('whitelist-domain-list', 'domain_group')
                        "
                        class="pc fw-500"
                      >
                        <i class="fas fa-plus-circle"></i> New
                      </a>
                    </div>
                  </div>
                </div>

                <!-- Set Internate Limit -->
                <h4 class="card-common-title p-0 mb-3">Set Internet Limit</h4>

                <div
                  v-for="(timeCategory, index) in value.timeCategories"
                  :key="index"
                  class="category-item"
                >
                  <div class="panel panel-default bg-light p-3 rounded mb-3">
                    <div class="d-flex align-items-center">
                      <div class="switch-row">
                        <!-- <label class="switch-label fw-600">WhiteList</label> -->

                        <label
                          >{{ timeCategory["CategoryName"] }}<br />
                          <div
                            style="
                              display: block;
                              font-size: 14px;
                              font-weight: normal;
                              color: #9d9d9d;
                              margin-top: 5px;
                              margin-bottom: 0;
                            "
                          >
                            <span
                              style="
                                color: #222;
                                display: inline-block;
                                margin-right: 5px;
                              "
                              ><i class="icon-clock"></i>
                              {{ timeCategory["frequency"] }}</span
                            >{{ timeCategory["startTime"] }} -
                            {{ timeCategory["EndTime"] }}
                          </div>
                          <router-link
                            :to="
                              $route.name == 'addGroupRule'
                                ? {
                                    name: 'addGroupTimeProfile',
                                    params: {
                                      id: value.id,
                                      group_name: value.grp_name,
                                      accountId: value.accountId,
                                      timeCategoryId: timeCategory['ID'],
                                    },
                                  }
                                : {
                                    name: 'addDeviceTimeProfile',
                                    params: {
                                      id: value.id,
                                      Device_MAC: value.dev_mac,
                                      accountId: value.accountId,
                                      timeCategoryId: timeCategory['ID'],
                                    },
                                  }
                            "
                            class="pc fw-500"
                            v-if="timeCategory.Activity"
                          >
                            <u>CHANGE SETTINGS</u>
                          </router-link>
                        </label>
                      </div>
                      <label class="switch ml-auto">
                        <input
                          type="checkbox"
                          @click="timeCategoryForceUpdate(index)"
                          v-model="timeCategory.Activity"
                          id="whitelist"
                        />
                        <div class="slider round"></div>
                      </label>
                    </div>
                  </div>
                </div>

                <!-- Qos -->
                <div
                  v-if="value.qos_id > 0"
                  class="panel panel-default bg-light p-3 rounded mb-3"
                >
                  <div class="d-flex align-items-center">
                    <div class="switch-row">
                      <label class="switch-label fw-600">Traffic Manager - QoS</label>
                    </div>
                    <label class="switch ml-auto">
                      <input
                        type="checkbox"
                        @click="sliderForceUpdate('qos_enable')"
                        v-model="value.qos_enable"
                        id="traffic_manager"
                      />
                      <div class="slider round"></div>
                    </label>
                  </div>
                  <div v-if="value.qos_enable" class="mt-3">
                    <div class="row form-group">
                      <label for="download" class="control-label col-md-12"
                        >Download Bandwidth</label
                      >
                      <div class="col-8">
                        <input
                          type="number"
                          v-model="value.download"
                          class="form-control"
                          placeholder="Enter value"
                        />
                      </div>

                      <div class="col-4">
                        <select class="form-control">
                          <option value="mbps">Mb/s</option>
                        </select>
                      </div>
                    </div>
                    <div class="row">
                      <label for="upload" class="control-label col-md-12"
                        >Upload Bandwidth</label
                      >
                      <div class="col-8">
                        <input
                          type="number"
                          v-model="value.upload"
                          class="form-control"
                          placeholder="Enter value"
                        />
                      </div>

                      <div class="col-4">
                        <select class="form-control">
                          <option value="mbps">Mb/s</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- @if($qosID > 0)
				<div class="switch-container">
					<div class="switch-heading">
						<h2>Traffic Manager - QoS</h2>
						<div class="switch">
							<input id="traffic_manager" name="qos_enable" {{$isactive ? 'checked':''}} type="checkbox">
							<label for="traffic_manager"><span>YES</span><span>NO</span> </label>
						</div>
					</div>
					<div class="traffic_manager" style="{{($isactive) ? 'display:block;' : 'display:none;'}}">
						<div class="form-horizontal">
							<div class="form-group">
								<label class="col-sm-2 control-label">Upload Bandwidth</label>
								<div class="col-xs-8">
									<input type="number" name="upload" value="{{$upload}}" class="form-control" placeholder="Enter value">
								</div>
								<div class="col-sm-2 col-xs-4">
									<select class="form-control">
										<option value="mbps">Mb/s</option>
									</select>
								</div>
							</div>
							<div class="form-group">
								<label class="col-sm-2 control-label">Download Bandwidth</label>
								<div class="col-xs-8">
									<input type="number" name="download" value="{{$download}}" class="form-control" placeholder="Enter value">
								</div>
								<div class="col-sm-2 col-xs-4">
									<select class="form-control">
										<option value="mbps">Mb/s</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			@endif -->
                <!-- Daily limit by hour -->
                <div class="panel panel-default bg-light p-3 rounded mb-3">
                  <div class="d-flex align-items-center">
                    <div class="switch-row">
                      <label class="switch-label fw-600">Daily Limit by Hours</label>
                    </div>
                    <label class="switch ml-auto">
                      <input
                        type="checkbox"
                        v-model="value.daily_limit_enable"
                        id="daily_limit_enable"
                      />
                      <div class="slider round"></div>
                    </label>
                  </div>
                </div>

                <div class="volume" v-if="value.daily_limit_enable">
                  <div class="windowsSlider">
                    <input
                      v-model="percent"
                      type="range"
                      class="windowsSliderInput"
                      min="0"
                      max="6"
                    />
                    <div
                      class="windowsSliderProgress"
                      :style="{ width: pre.sliderWidth[percent] + '%' }"
                    ></div>
                  </div>
                  <p>{{ pre.dailyLimit[percent] }}</p>
                </div>

                <!-- Exception -->
                <div class="panel panel-default bg-light p-3 rounded mb-3">
                  <div class="d-flex align-items-center">
                    <div class="switch-row">
                      <label class="switch-label fw-600">Exception</label>
                    </div>
                    <label class="switch ml-auto">
                      <input
                        type="checkbox"
                        @click="sliderForceUpdate('exception_group_enbale')"
                        v-model="value.exception_group_enbale"
                        id="exception_group_enbale"
                      />
                      <div class="slider round"></div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card-footer pt-0 pb-4">
            <button type="submit" @click="handleSubmission()" class="btn">Submit</button>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import { CommonAPI, PermissionChecker } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import "vue2-datepicker/index.css";
import { mapGetters } from "vuex";

export default {
  name: "addDeviceRule",
  metaInfo: {
    title: "Add Device Rule | Dotlines",
  },
  components: {},
  data: () => ({
    percent: 0,
    value: {},
    api_url: "",
    dateRange: "",
    pre: {
      blockedCategories: [],
      protocols: ["TCP", "ICMP", "UDP"],
      flagOptions: ["ACK", "FIN", "PSH", "RST", "SYN", "ALL", "NONE"],
      connStates: ["RELATED", "NEW", "ESTABLISHED", "INVALID"],
      sliderWidth: [0, 16, 33, 50, 67, 83, 100],
      dailyLimit: [1, 2, 4, 8, 12, 20, 24],
    },
    is_loading: false,
    empty: false,
    empty_message: "",
    custom_permission_data: [],
    has_permission: true,
    title: "Add Group Rule",
    hasBlockSitesError: false,
    hasWhiteListError: false,
  }),
  mounted: function () {
    if (this.isMobile()) {
      window.$(document).find(".push-menu-class").trigger("click");
    }

    this.params = this.$route.params;

    this.setUrl();

    this.initialize();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.reload();
    });
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  methods: {
    setUrl() {
      if (this.$route.name == "addDeviceRule") {
        this.title = "Add Device Rule";
        this.api_url =
          "/addDeviceRule/" +
          this.params.id +
          "/" +
          this.params.group_name +
          "/" +
          this.params.Device_MAC +
          "/" +
          this.params.accountId +
          "/" +
          this.params.ip_address;
      } else {
        this.api_url =
          "/addGroupRule/" +
          this.params.id +
          "/" +
          this.params.group_name +
          "/" +
          this.params.accountId;
      }
    },

    handleSubmission() {
      const _this = this;
      const currentRouteName = this.$route.name;
      this.$validator.validateAll().then((result) => {
        if (result && this.hasWhiteListError == false && this.hasBlockSitesError == false) {
          _this.is_loading = true;

          _this.fixBooleanValue();
          _this.value.daily_limit_by_hour = _this.pre.dailyLimit[_this.percent];
          axios({
            method: "POST",
            url: "/saveRules",
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              if (currentRouteName == "addGroupRule") {
                _this.$router.push({ name: "GroupInfoList" });
              } else {
                _this.$router.push({ name: "DeviceList" });
              }
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        } else {
          console.log("Validation failed");
          this.$validator.errors.items.forEach((error) => {
            console.log(`Field: ${error.field}, Error message: ${error.msg}`);
            _this.errorsObj[error.field] = error.msg;
          });
        }
      });
    },
    async initialize() {
      this.is_loading = true;
      if (_.isEmpty(this.profile)) {
        await CommonAPI.getProfile().then((profile_info) => {
          this.user_detail = profile_info;
        });
      } else {
        this.user_detail = this.profile;
      }

      await CommonAPI.getCustomPermission(
        "/get-custom-permission-infos?path=api/addDeviceRule"
      ).then((response) => {
        if (response.status == 200) {
          this.custom_permission_data = response.data;
        }
      });

      if (!_.isEmpty(this.custom_permission_data)) {
        this.actionCreate = await PermissionChecker.checkCreateButtonPermission(
          this.custom_permission_data.action_permission,
          this.custom_permission_data["create_id_condition"],
          this.user_detail,
          this.custom_permission_data.enableAdministratorPermissionByDefault
        );
      }

      await this.getList()
        .then((response) => {
          this.value = response.data;

          console.log(this.value);
          this.initializeValue();
        })
        .catch((error) => {
          this.empty = true;
          if (error.response.status === 403) {
            this.has_permission = false;
          }
        });

      this.is_loading = false;
    
    },

    setDomainsErrors(event) {
      const field = event.target.name;
      if (event.target.name == 'blockSitesUserDefined') {
        this.hasBlockSitesError = this.validateDomains(event.target.value)? false : true;
      } else if (event.target.name == 'whitelistSitesUserDefined') {
        this.hasWhiteListError = this.validateDomains(event.target.value)? false : true;
      }
    },

    validateDomains: function (value) {
      if (value && value.length > 0) {
        const domains = value.split(",")
        for (let i = 0; i < domains.length; i++) {
          if (domains[i].length > 50) {
            return false;
          }
        }
      }
      return true;
    },

    initializeValue() {
      this.value.qos_id = this.value.qosID;
      this.value.current_group_name = this.value.grp_name;
      this.value.tableID = this.value.id;
      this.value.source_address = this.value.sourceAddress;
      this.value.rule_for = this.value.ruleFor;

      this.value.blocksite_enable = this.value.blocksites_enable_default;
      this.value.blockcategory_enable = this.value.blockcategory_enable_default;
      this.value.whilelist_enable = this.value.whiteList_enable_default;
      this.value.whitelistSitesUserDefined = this.value.whiteListUserDefinedDefaultString;
      this.value.blockSitesWhiteList = this.value.whiteListDefaultAry;
      this.value.exception_group_enbale = this.value.exception_group_enable_default;
      this.value.blockcategory = this.value.blockCategoriesDefaultAry;
      this.value.enabledBlockSites = this.value.blockSitesDefaultAry;
      this.value.blockSitesUserDefined = this.value.blockSitesUserDefinedDefaultString;
      this.value.blocked_ip_group_enable = this.value.block_ipGroup_enable_default;
      this.value.blocked_domain_group_enable = this.value.block_domainGroup_enable_default;
      this.value.whitelist_ip_group_enable = this.value.white_ipGroup_enable_default;
      this.value.whitelist_domain_group_enable = this.value.white_domainGroup_enable_default;
      this.value.qos_enable = this.value.isactive;
      this.percent = this.value.daily_limit_by_hour
        ? this.pre.dailyLimit.indexOf(this.value.daily_limit_by_hour)
        : 0;
      this.initializeGroupList("block-ip-list", this.value.ipGroupDefault, "ip_group");
      this.initializeGroupList(
        "block-domain-list",
        this.value.domainGroupDefault,
        "domain_group"
      );
      this.initializeGroupList(
        "whitelist-ip-list",
        this.value.whiteListIPGroupDefault,
        "ip_group"
      );
      this.initializeGroupList(
        "whitelist-domain-list",
        this.value.whiteListDomainGroupDefault,
        "domain_group"
      );
      this.initializeTimeCategory();
    },

    getList: function () {
      return new Promise((resolve, reject) => {
        const params = { accountId: LocalStorage.get("accountId") };
        axios
          .get(this.api_url, {
            params: params,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
            // console.log("error", error.response.data);
          })
          .finally(() => {
            // _this.is_loading = false;
          });
      });
    },

    addRemoveCategory(categories, category) {
      const index = this.value[categories].indexOf(category);
      if (index === -1) {
        this.value[categories].push(category);
      } else {
        this.value[categories].splice(index, 1);
      }
      this.forceUpdate();
    },

    addMoreGroup(group, groupDropDown) {
      this.value[group].push({
        [groupDropDown]: "",
        id: "",
        is_advance: "",
        protocol: "ICMP",
        "tcp-source-port": "",
        "tcp-destination-port": "",
        "tcp-flag": [],
        "tcp-mask": [],
        "conn-state": [],
        "tcp-limit-s": "",
        "tcp-burst-rate": "",
        "tcp-conn-limit-value": "",
        "tcp-conn-limit-mask": "",
        "udp-source-port": "",
        "udp-destination-port": "",
        "udp-limit-s": "",
        "udp-burst-rate": "",
        "icmp-type": "",
        "icmp-limit": "",
      });
      this.$forceUpdate();
    },

    removeGroup(index, group) {
      this.value[group].splice(index, 1);
      this.$forceUpdate();
    },

    initializeGroupList(group, groupDefault, groupDropDown) {
      this.value[group] = [];
      for (let index = 0; index < groupDefault.length; index++) {
        this.value[group].push({
          [groupDropDown]: groupDefault[index][groupDropDown],
          id: groupDefault[index].id,
          is_advance: groupDefault[index].is_advance,
          protocol: groupDefault[index].protocol,
          "tcp-source-port": groupDefault[index].tcp_source_port,
          "tcp-destination-port": groupDefault[index].tcp_destination_port,
          "tcp-limit-s": groupDefault[index].tcp_limit,
          "tcp-burst-rate": groupDefault[index].tcp_burst_rate,
          "tcp-conn-limit-value": groupDefault[index].tcp_conn_limit_value,
          "tcp-conn-limit-mask": groupDefault[index].tcp_Conn_limit_mask,
          "udp-source-port": groupDefault[index].udp_source_port,
          "udp-destination-port": groupDefault[index].udp_destination_port,
          "udp-limit-s": groupDefault[index].udp_limit,
          "udp-burst-rate": groupDefault[index].udp_burst_rate,
          "icmp-type": groupDefault[index].icmp_type,
          "icmp-limit": groupDefault[index].icmp_limit,
          "tcp-flag": groupDefault[index].tcp_flag,
          "tcp-mask": groupDefault[index].tcp_mask,
          "conn-state": groupDefault[index].conn_state,
        });
      }
    },
    checkboxForceUpdate(index, group) {
      if (this.value[group][index].is_advance) {
        this.value[group][index].is_advance = 0;
      } else {
        this.value[group][index].is_advance = 1;
      }
      this.$forceUpdate();
    },
    sliderForceUpdate(slider) {
      if (this.value[slider]) {
        this.value[slider] = 0;
      } else {
        this.value[slider] = 1;
      }
      this.$forceUpdate();
    },

    timeCategoryForceUpdate(index) {
      if (this.value.timeCategories[index].Activity) {
        this.value.timeCategories[index].Activity = 0;
      } else {
        this.value.timeCategories[index].Activity = 1;
      }
      this.$forceUpdate();
    },

    initializeTimeCategory() {
      this.value.time_category_id = [];
      for (let index = 0; index < this.value.timeCategories.length; index++) {
        this.value.time_category_id[index] = this.value.timeCategories[index].ID;
        if (this.value.timeCategories[index].Activity == "active") {
          this.value.timeCategories[index].Activity = true;
        } else {
          this.value.timeCategories[index].Activity = false;
        }
      }
    },

    fixBooleanValue() {
      const valueKeyes = Object.keys(this.value);

      for (let i = 0; i < valueKeyes.length; i++) {
        if (typeof this.value[valueKeyes[i]] == "boolean") {
          this.value[valueKeyes[i]] = this.value[valueKeyes[i]] ? 1 : 0;
        }
      }

      this.value.category = {};
      for (let i = 0; i < this.value.timeCategories.length; i++) {
        if (this.value.timeCategories[i].Activity) {
          this.value.category[i] = "on";
        }
      }

      this.fixGroupBooleanValue("block-ip-list", "block-ip-list-advanced-selector");
      this.fixGroupBooleanValue(
        "block-domain-list",
        "block-domain-list-advanced-selector"
      );
      this.fixGroupBooleanValue(
        "whitelist-ip-list",
        "whitelist-ip-list-advanced-selector"
      );
      this.fixGroupBooleanValue(
        "whitelist-domain-list",
        "whitelist-domain-list-advanced-selector"
      );
    },

    fixGroupBooleanValue(group, advanceSelector) {
      for (let index = 0; index < this.value[group].length; index++) {
        if (this.value[group][index].is_advance) {
          this.value[group][index][advanceSelector] = { 0: "on" };
        }
      }
    },

    forceUpdate() {
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
/* h1 {
  font-family: cursive;
  color: white;
  margin-top: 20px;
} */
.windowsSlider {
  height: 5px;
  border-radius: 5px;
  /*   transform: scale(2); */
  background: #00000060;

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.windowsSliderInput {
  -webkit-appearance: none;
  background: transparent;
  outline: none;
  border: none;
  height: 100%;
  width: 100%;
  border-radius: 5px;
  z-index: 2;
}
.windowsSliderInput::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  cursor: pointer;
  transition: box-shadow 0.5s;
  background: #198f85;
  box-shadow: 0 0 0 6px #1a1a1a;
}
.windowsSliderInput:active::-webkit-slider-thumb {
  box-shadow: 0 0 0 6px #1a1a1a, 0 0 0 15px #198f8570;
}
.windowsSliderInput::-moz-range-thumb {
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  cursor: pointer;
  transition: box-shadow 0.5s;
  background: #198f85;
  box-shadow: 0 0 0 6px #1a1a1a;
}
.windowsSliderInput:active::-moz-range-thumb {
  box-shadow: 0 0 0 6px #1a1a1a, 0 0 0 15px #198f8570;
}
.windowsSliderProgress {
  position: absolute;
  left: 0;
  width: 50%;
  height: 100%;
  border-radius: 5px;
  background: #198f85;
  z-index: 1;
}
</style>
